import { render, staticRenderFns } from "./commonText.vue?vue&type=template&id=7a4e1339&scoped=true"
import script from "./commonText.vue?vue&type=script&lang=js"
export * from "./commonText.vue?vue&type=script&lang=js"
import style0 from "./commonText.vue?vue&type=style&index=0&id=7a4e1339&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e1339",
  null
  
)

export default component.exports